import { IHinhThucChiTiet } from "../../model/respone/mien-giam/IHinhThucChiTiet";
import { apiClient } from "../apiClient";
export const HINH_THUC_CHI_TIET_ENDPOINT = "mien-giam/hinh-thuc-chi-tiet";
export const hinhThucChiTietApi = {
  SelectAll: (IDHinhThuc: number) =>
    apiClient.get(`hinh-thuc/${IDHinhThuc}/chi-tiet`),
  Insert: (payload: IHinhThucChiTiet) =>
    apiClient.post(`${HINH_THUC_CHI_TIET_ENDPOINT}`, payload),
  Update: (payload: IHinhThucChiTiet) =>
    apiClient.put(`${HINH_THUC_CHI_TIET_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${HINH_THUC_CHI_TIET_ENDPOINT}/${id}`),
};
